import type { Resource } from '../../';
export const product_price_discountPercent: Resource = {"default":"{percent}% off"};
